import React from 'react';
import { AlertTriangle, Database, Wifi, WifiOff, Globe, Mail } from 'lucide-react';

export const ActivationPage: React.FC = () => {
  const isOnline = navigator.onLine;

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 dark:from-red-900/20 dark:to-orange-900/20 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <AlertTriangle className="w-16 h-16 text-red-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
            Account Activation Required
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Your account needs to be activated to access the Professional Inventory Management System.
          </p>
        </div>

        {/* System Status */}
        <div className="space-y-4 mb-6">
          <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
            <div className="flex items-center">
              <Database className="w-5 h-5 text-blue-500 mr-2" />
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Supabase Database</span>
            </div>
            <span className="text-sm font-medium text-green-600">
              ✅ Connected
            </span>
          </div>

          <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
            <div className="flex items-center">
              {isOnline ? (
                <Wifi className="w-5 h-5 text-green-500 mr-2" />
              ) : (
                <WifiOff className="w-5 h-5 text-red-500 mr-2" />
              )}
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Network</span>
            </div>
            <span className={`text-sm font-medium ${isOnline ? 'text-green-600' : 'text-red-600'}`}>
              {isOnline ? '✅ Online' : '❌ Offline'}
            </span>
          </div>
        </div>

        {/* Activation Instructions */}
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-6">
          <h3 className="text-sm font-medium text-blue-800 dark:text-blue-300 mb-2">
            How to Get Activated
          </h3>
          <div className="text-sm text-blue-600 dark:text-blue-400 space-y-1">
            <p>1. Contact your system administrator</p>
            <p>2. Request account activation</p>
            <p>3. Provide your email address for verification</p>
            <p>4. Wait for activation confirmation</p>
          </div>
        </div>

        {/* Contact Information */}
        <div className="text-sm text-gray-500 dark:text-gray-400 mb-6 space-y-2">
          <div className="flex items-center justify-center">
            <Mail className="w-4 h-4 mr-2" />
            <span>Support: </span>
            <a 
              href="mailto:support@getinv.app" 
              className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 ml-1"
            >
              support@getinv.app
            </a>
          </div>
          <div className="flex items-center justify-center">
            <Globe className="w-4 h-4 mr-2" />
            <span>Website: </span>
            <a 
              href="https://www.getinv.app/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 ml-1"
            >
              www.getinv.app
            </a>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
          >
            Check Activation Status
          </button>
          
          <button
            onClick={() => window.location.href = '/login'}
            className="w-full bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-medium py-2 px-4 rounded-lg transition-colors"
          >
            Back to Login
          </button>
        </div>

        {/* System Information */}
        <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
          <p className="text-xs text-gray-400 dark:text-gray-500">
            Professional Inventory Management System v1.0.0
          </p>
          <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
            Powered by Supabase Database
          </p>
        </div>
      </div>
    </div>
  );
};